// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__z8n1N","header":"style_header__Tpwzx","header_meta":"style_header_meta__Ub6gP","section":"style_section__wIY2I"};